import { useEffect, useRef, useState } from 'react'

import { useActionCableConsumer } from '@/lib/ActionCableContext'

export interface UnassignedAssistance {
  id: string
  start_time: string
  category: 'DEP' | 'ARR'
  booking: { id: string; ref: string }
}

interface UnassignedAlarmPayload {
  type: 'unassigned_alarm'
  idempotency_key: string
  unassigned_assistances: UnassignedAssistance[]
}

export const useStationAlarmsChannel = (stationCode: string | null) => {
  const consumer = useActionCableConsumer()
  const [unassignedAlarms, setUnassignedAlarms] = useState<UnassignedAssistance[]>([])
  const lastIdempotencyKey = useRef<string | null>(null)

  useEffect(() => {
    if (!stationCode) return
    if (!consumer) return

    const subscription = consumer.subscriptions.create(
      { channel: 'RRMS::StationAlarmsChannel', station_code: stationCode },
      {
        received: (data: UnassignedAlarmPayload) => {
          if (data.idempotency_key === lastIdempotencyKey.current) return

          lastIdempotencyKey.current = data.idempotency_key
          setUnassignedAlarms(data.unassigned_assistances)
        },
      }
    )

    return () => {
      subscription.unsubscribe()
      lastIdempotencyKey.current = null
      setUnassignedAlarms([])
    }
  }, [stationCode, consumer])

  return { unassignedAlarms }
}
